var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C1B1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.707 3.503H28.28c.695 0 1.26-.769 1.26-1.716S28.975.071 28.28.071H9.707C9.012.071 8.45.84 8.45 1.787s.563 1.716 1.258 1.716zM27.822 8.651H2.512a1.717 1.717 0 0 0 0 3.432h25.31a1.717 1.717 0 0 0 0-3.432zM28.279 17.089H9.707c-.695 0-1.258.769-1.258 1.716s.563 1.716 1.258 1.716H28.28c.695 0 1.26-.769 1.26-1.716s-.565-1.716-1.261-1.716z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.5a3e8c7630533e63d04c75ffef889d1d.svg";
export { ForwardRef as ReactComponent };